// Configuration for different environments
const config = {
  development: {
    apiUrl: 'http://localhost:5000/api',
  },
  production: {
    apiUrl: process.env.REACT_APP_API_URL || 'https://travelit-backend.sitekdigital.workers.dev/api',
  },
};

// Determine current environment
const env = process.env.NODE_ENV || 'development';

// Export the configuration for the current environment
export default config[env]; 